module.exports = __webpack_public_path__ + "img/indetail.84c25a4b.jpg";